import { Views, FollowUp, Orgenization, Favourites, Ideas, Business, Holidays, Important, Personal } from '../../../../Constant';
import CreateContact from './CreateContact';
import CategoryCreate from './CategoryCreate';
import { Nav, NavItem } from 'reactstrap';
import React, { Fragment, useState } from 'react';

const NavComponent = ({ callbackActive }) => {
    const [activeTab, setActiveTab] = useState('1');

    return (
        <Fragment>
            <Nav className="main-menu contact-options" role="tablist">
                <NavItem>
                    <CreateContact />
                </NavItem>
                <hr />
                <NavItem>
                    <a href="#javascript" className={activeTab === '1' ? 'active' : ''} onClick={() => {
                        setActiveTab('1'); callbackActive('1');
                    }}><span className="title"> {"All Departmental Units"}</span></a>
                </NavItem>
               
                <NavItem><a href="#javascript" className={activeTab === '2' ? 'active' : ''} onClick={() => {
                    setActiveTab('2'); callbackActive('2');
                }}><span className="title"> {"Units By Ministry "}</span></a></NavItem>
                <NavItem><a href="#javascript" className={activeTab === '3' ? 'active' : ''} onClick={() => {
                    setActiveTab('3'); callbackActive('3');
                }}><span className="title">{"Units Department"}</span></a></NavItem>
				
				
				
                <hr />
            </Nav>
        </Fragment>
    );
};

export default NavComponent;